const defaultState = {
  snack: {},
};

const getters = {};

const mutations = {
  track: (state, { category, action, label }) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "Generic Event",
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
    });
  },
  snack: (state, { type, text }) => {
    state.snack = {
      type,
      text,
    };
  },
};

const actions = {
  snackSuccess: ({ commit }, text) => {
    commit("snack", { type: "primary", text });
  },
  snackError: ({ commit }, text) => {
    commit("snack", { type: "error", text });
  },
  unsnack: ({ commit }) => {
    commit("snack", { type: null, text: null });
  },
  trackErrors: ({ commit }, errors = []) => {
    errors.forEach((err) => {
      commit("track", {
        category: "Error",
        action: err.error.code,
        label: err.error.message,
      });
    });
  },
};

export default {
  namespaced: false,
  state: defaultState,
  getters,
  actions,
  mutations,
};
